































































































import MultilineInput from 'vuecomponents/multiline_input.vue'
import OutsideEventsMixin from 'vuemixins/outside_events_mixin'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Id, Section } from 'types'
import { Getter, namespace, State } from 'vuex-class'

@Component({
  components: { MultilineInput, OzTextButton, OzIcon },
  mixins: [OutsideEventsMixin],
})
export default class SurfaceSectionTitleNew extends Mixins() {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  $refs!: {
    title: MultilineInput & { $el: HTMLTextAreaElement }
  }
  @Prop() section!: Section
  @Prop() sectionBeingEditedId!: Id
  maxLength = 512

  @State isWallOnboardingFlow!: boolean
  @State isIOS!: boolean
  @(namespace('section').Getter) sections!: Section[]
  @Getter canIModerate!: boolean
  @Getter canIEdit!: boolean
  @Getter colorScheme!: 'light' | 'dark'
  @Getter fontId!: number
  @Getter dir!: 'ltr' | 'rtl'

  get tailwindFontClass(): string {
    switch (this.fontId) {
      case 1:
        return 'font-sans'
      case 2:
        return 'font-serif'
      case 3:
        return 'font-cursive'
      case 4:
        return 'font-padlet-monospace'
      default:
        return 'font-sans'
    }
  }

  get sectionTitle() {
    return this.section.title
  }

  get isBeingEdited() {
    // We need to also check that we're not in the first view flow for a section title to be
    // in the edit state, otherwise
    // the first view panel cannot get focus -- it'll keep dithering between the section
    // title and the first view panel's text fields.
    return this.sectionBeingEditedId && this.sectionBeingEditedId === this.section.id && !this.isWallOnboardingFlow
  }
  get wallSectionsLength() {
    return this.sections.length
  }
  get isEmptyState() {
    return this.isBeingEdited && this.wallSectionsLength === 1
  }
  get titlePlaceholder() {
    if (this.isEmptyState) {
      return this.__('Name your first section')
    }
    return this.__('Name your section')
  }

  @Watch('isBeingEdited')
  handleIsBeingEdited(val) {
    if (val) {
      this.$nextTick(() => {
        this.$refs.title.focus()
      })
    }
  }

  mounted() {
    if (this.isBeingEdited) {
      this.$nextTick(() => {
        this.$refs.title.focus()
      })
    }
  }

  @(namespace('section').Action) changeSectionTitle!: (payload: { sectionId?: Id; title: string }) => void
  @(namespace('section').Action) stopEditingSection!: () => void
  @(namespace('section').Action) startEditingSection!: (payload: { sectionId?: Id }) => void
  @(namespace('section').Action) showSectionActionMenu!: (payload: { sectionId?: Id }) => void
  @(namespace('snackbars').Action) setSnackbar!: (payload: { message: string }) => void

  saveTitle() {
    const sanitizedTitle = this.$refs.title.$el.value.replace(/\n|\r/g, '')
    if (sanitizedTitle.length > 0) {
      this.changeSectionTitle({ sectionId: this.section.id, title: sanitizedTitle })
    } else {
      const message = this.__('Section title cannot be empty.')
      this.setSnackbar({ message })
    }
  }
  tryStartEditing() {
    if (this.canIEdit && !this.isBeingEdited) {
      this.startEditingSection({ sectionId: this.section.id })
    }
  }
  deleteSection() {
    this.$emit('delete')
  }
  onOutsideClick() {
    if (!this.isBeingEdited) return

    const sanitizedTitle = this.$refs.title.$el.value.replace(/\n|\r/g, '')
    if (sanitizedTitle.length > 0) {
      this.changeSectionTitle({ sectionId: this.section.id, title: sanitizedTitle })
    } else {
      this.stopEditingSection()
    }
  }
}
